import React, { useState, FC, useEffect, useLayoutEffect } from 'react'
import { Button } from '../../../../ps-aspect-design';
import MinimumWage from './MinimumWage/MinimumWage'
import SurveyData from './SurveyData/SurveyData';
import { TableauAdmin } from './TableauAdmin/TableauAdmin';
import '../../MarketPayInternal.scss';
import { useQueryParams } from '../../../../hooks/util'
import { useHistory, useLocation } from 'react-router-dom';

interface InternalToolsView {
    key: InternalToolsViewKey
    label: InternalToolsViewLabel
    Component: FC
    queryParam: string
}

enum InternalToolsViewKey {
    minimumWage = 'MINIMUM_WAGE',
    surveyDataMangement = 'SURVEY_DATA',
    tableauAdmin = 'TABLEAU_ADMIN'
}

enum InternalToolsViewLabel {
    minimumWage = 'Minimum Wages',
    surveyDataMangement = 'Survey Data Management',
    tableauAdmin = 'Tableau Admin'
}

const InternalTools = () => {
    const [view, setView] = useState<InternalToolsViewKey>(InternalToolsViewKey.minimumWage);
    const history = useHistory();
    const location = useLocation();
    const query = useQueryParams()
    const tool = query.get('tool')

    useLayoutEffect(() => {
        if (tool?.toLocaleLowerCase() === 'minimumwage') setView(InternalToolsViewKey.minimumWage)
        if (tool?.toLocaleLowerCase() === 'surveydatamanagement') setView(InternalToolsViewKey.surveyDataMangement)
        if (tool?.toLocaleLowerCase() === 'tableauadmin') setView(InternalToolsViewKey.tableauAdmin)
    }, [tool])

    const VIEWS: InternalToolsView[] = [
        { key: InternalToolsViewKey.minimumWage, label: InternalToolsViewLabel.minimumWage, Component: MinimumWage, queryParam: 'minimumwage' },
        { key: InternalToolsViewKey.surveyDataMangement, label: InternalToolsViewLabel.surveyDataMangement, Component: SurveyData, queryParam: 'surveydatamanagement'},
        { key: InternalToolsViewKey.tableauAdmin, label: InternalToolsViewLabel.tableauAdmin, Component: TableauAdmin, queryParam: 'tableauadmin' }
    ]

    const handleTabChange = (view: InternalToolsView) => {
        setView(view.key)
        const params = new URLSearchParams(location.search);
        params.set('tool', view.queryParam);
        history.push({ search: params.toString() });
    }

    return (
        <div>
            {VIEWS.map(v =>
                <Button
                    key={v.key}
                    variant={v.key === view ? 'primary' : 'secondary'}
                    onClick={() => handleTabChange(v)}
                >
                    {v.label}
                </Button>)
            }

            {VIEWS.map(v => (v.key === view && <v.Component key={v.key} />))}
        </div>
    )
}

export default InternalTools